import React, { useState } from "react";
import TitleComponent from "../../components/title/Title";
import SearchComponent from "../../components/search/SearchComp";
import GradientButton from "../../components/button/Button";
import CustomersTable from "./CustomersTable";
import CustomersAnalytics from "./CustomersAnalytics";

function CustomersMain() {
  const [activeTab, setActiveTab] = useState("list");

  const orders = [
    {
      id: "PAM-62721",
      amount: "120.13",
      date: "January 10, 2024",
      items: 2,
    },
    {
      id: "PAM-62722",
      amount: "250.75",
      date: "January 11, 2024",
      items: 3,
    },
  ];

  const handleAccept = (id: string) => {
    alert(`Order ${id} accepted!`);
  };

  const handleCancel = (id: string) => {
    alert(`Order ${id} canceled!`);
  };
  const renderContent = () => {
    switch (activeTab) {
      case "analytics":
        return <CustomersAnalytics />;
      case "list":
        return <CustomersTable />;
      default:
        return null;
    }
  };

  return (
    <div className="body--container">
      <TitleComponent title="Customers" />
      <div className="requests-tabs">
        {/* Tabs */}
        {/* <button
          className={`requests-tabs__tab ${
            activeTab === "analytics" ? "requests-tabs__tab--active" : ""
          }`}
          onClick={() => setActiveTab("analytics")}
        >
          Analytics
        </button> */}
        {/* <button
          className={`requests-tabs__tab ${
            activeTab === "list" ? "requests-tabs__tab--active" : ""
          }`}
          onClick={() => setActiveTab("list")}
        >
          List
        </button> */}
      </div>

      {/* <div className="requests__search_section">
        <SearchComponent onSearch={() => null} />
        <GradientButton text="Search" />
      </div> */}
      <div className="requests-content">{renderContent()}</div>
    </div>
  );
}

export default CustomersMain;
